import { styled } from '@linaria/react';
import { fonts, primitives, radius, semantic, space } from '../../theme/tokens';

export const StyledBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  padding: ${space['space-100']} ${space['space-300']};
  border-radius: ${radius('chip', 'radius-full')};
  background: ${semantic.bg.urgencyStrong};
  color: ${semantic.text.inverse};

  &[data-tone='sale'] {
    border-radius: ${radius('chip', 'radius-xs')};
  }

  &[data-size='extraSmall'] {
    font-size: ${fonts.size.xs};
    padding: ${space['space-050']} ${space['space-100']};
    border-radius: ${radius('chip', 'radius-xs')};
  }

  &[data-tone='neutral'] {
    background: ${semantic.bg.surfaceSubtle};
    color: ${semantic.text.primary};
  }

  &[data-tone='success'] {
    background: ${semantic.bg.positiveSubtle};
    color: ${semantic.text.positive};
  }

  &[data-tone='info'] {
    background: ${semantic.bg.infoSubtle};
    color: ${semantic.text.info};
  }

  &[data-tone='danger'] {
    background: ${semantic.bg.dangerSubtle};
    color: ${semantic.text.danger};
  }

  &[data-tone='brand'] {
    background: ${semantic.bg.brand};
    color: ${semantic.text.onBrand};
  }
`;
